import script from "./GiftExhibition.vue?vue&type=script&lang=ts&setup=true&name=GiftExhibition"
export * from "./GiftExhibition.vue?vue&type=script&lang=ts&setup=true&name=GiftExhibition"

const __exports__ = script;

export default __exports__